<template>
  <v-chip v-if="present" small color="warning" text-color="white">
    <v-icon small left>mdi-alert</v-icon>{{ $t('present') }}
  </v-chip>
  <v-chip v-else small color="success" text-color="white">
    <v-icon small left>mdi-check</v-icon>{{ $t('notPresent') }}
  </v-chip>
</template>

<script>
export default {
  name: 'PresenceChip',

  props: {
    present: {
      type: Boolean,
      default: false
    }
  }
}
</script>
